webpackJsonp([9],{

/***/ "3CVM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.8.0@vux/src/components/loading/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var loading = ({
  name: 'loading',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: Boolean,
    text: String,
    position: String,
    transition: {
      type: String,
      default: 'vux-mask'
    }
  },
  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.8.0@vux/src/components/loading/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_loading = ({
  name: 'loading',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: Boolean,
    text: String,
    position: String,
    transition: {
      type: String,
      default: 'vux-mask'
    }
  },
  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-7fb25c1b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vux-loader@1.2.9@vux-loader/src/before-template-compiler-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/template-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./node_modules/_vux@2.8.0@vux/src/components/loading/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":_vm.transition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-loading_toast vux-loading"},[_c('div',{staticClass:"weui-mask_transparent"}),_vm._v(" "),_c('div',{staticClass:"weui-toast",style:({ position: _vm.position })},[_c('i',{staticClass:"weui-loading weui-icon_toast"}),_vm._v(" "),_c('p',{staticClass:"weui-toast__content"},[_vm._v(_vm._s(_vm.text || '加载中')),_vm._t("default")],2)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_loading = (esExports);
// CONCATENATED MODULE: ./node_modules/_vux@2.8.0@vux/src/components/loading/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("Esch")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_loading,
  src_components_loading,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ var _vux_2_8_0_vux_src_components_loading = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Esch":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("+RKF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("HVJf");



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var state = {
	isLoading: false,
	token: '',
	reg: { //正则reg验证
		phoneNum: /^1+\d{10}$/, //手机号验证
		email: /^\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}$/ //邮箱验证
	},
	foundPhoneNum: {
		phone: '',
		userId: ''
	}
};

var actions = {};

var getters = {};

var mutations = {
	updateLoadingStatus: function updateLoadingStatus(state, payload) {
		state.isLoading = payload.isLoading;
	},
	updateToken: function updateToken(state, newToken) {
		state.token = newToken;
	},
	updatePhoneNum: function updatePhoneNum(state, phoneInfo) {
		state.foundPhoneNum.phone = phoneInfo.phone;
		state.foundPhoneNum.userId = phoneInfo.userId;
	}
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
	state: state,
	actions: actions,
	getters: getters,
	mutations: mutations
}));

/***/ }),

/***/ "MX9l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/_vux@2.8.0@vux/src/mixins/safari-fix.js
var safari_fix = __webpack_require__("ExSH");

// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.8.0@vux/src/components/toast/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var toast = ({
  name: 'toast',
  mixins: [safari_fix["a" /* default */]],
  props: {
    value: Boolean,
    time: {
      type: Number,
      default: 2000
    },
    type: {
      type: String,
      default: 'success'
    },
    transition: String,
    width: {
      type: String,
      default: '7.6em'
    },
    isShowMask: {
      type: Boolean,
      default: false
    },
    text: String,
    position: String
  },
  data: function data() {
    return {
      show: false
    };
  },
  created: function created() {
    if (this.value) {
      this.show = true;
    }
  },

  computed: {
    currentTransition: function currentTransition() {
      if (this.transition) {
        return this.transition;
      }
      if (this.position === 'top') {
        return 'vux-slide-from-top';
      }
      if (this.position === 'bottom') {
        return 'vux-slide-from-bottom';
      }
      return 'vux-fade';
    },
    toastClass: function toastClass() {
      return {
        'weui-toast_forbidden': this.type === 'warn',
        'weui-toast_cancel': this.type === 'cancel',
        'weui-toast_success': this.type === 'success',
        'weui-toast_text': this.type === 'text',
        'vux-toast-top': this.position === 'top',
        'vux-toast-bottom': this.position === 'bottom',
        'vux-toast-middle': this.position === 'middle'
      };
    },
    style: function style() {
      if (this.type === 'text' && this.width === 'auto') {
        return { padding: '10px' };
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this = this;

      if (val) {
        this.$emit('input', true);
        this.$emit('on-show');
        this.fixSafariOverflowScrolling('auto');

        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          _this.show = false;
          _this.$emit('input', false);
          _this.$emit('on-hide');
          _this.fixSafariOverflowScrolling('touch');
        }, this.time);
      }
    },
    value: function value(val) {
      this.show = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.8.0@vux/src/components/toast/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_toast = ({
  name: 'toast',
  mixins: [safari_fix["a" /* default */]],
  props: {
    value: Boolean,
    time: {
      type: Number,
      default: 2000
    },
    type: {
      type: String,
      default: 'success'
    },
    transition: String,
    width: {
      type: String,
      default: '7.6em'
    },
    isShowMask: {
      type: Boolean,
      default: false
    },
    text: String,
    position: String
  },
  data: function data() {
    return {
      show: false
    };
  },
  created: function created() {
    if (this.value) {
      this.show = true;
    }
  },

  computed: {
    currentTransition: function currentTransition() {
      if (this.transition) {
        return this.transition;
      }
      if (this.position === 'top') {
        return 'vux-slide-from-top';
      }
      if (this.position === 'bottom') {
        return 'vux-slide-from-bottom';
      }
      return 'vux-fade';
    },
    toastClass: function toastClass() {
      return {
        'weui-toast_forbidden': this.type === 'warn',
        'weui-toast_cancel': this.type === 'cancel',
        'weui-toast_success': this.type === 'success',
        'weui-toast_text': this.type === 'text',
        'vux-toast-top': this.position === 'top',
        'vux-toast-bottom': this.position === 'bottom',
        'vux-toast-middle': this.position === 'middle'
      };
    },
    style: function style() {
      if (this.type === 'text' && this.width === 'auto') {
        return { padding: '10px' };
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this = this;

      if (val) {
        this.$emit('input', true);
        this.$emit('on-show');
        this.fixSafariOverflowScrolling('auto');

        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          _this.show = false;
          _this.$emit('input', false);
          _this.$emit('on-hide');
          _this.fixSafariOverflowScrolling('touch');
        }, this.time);
      }
    },
    value: function value(val) {
      this.show = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-aecf1752","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vux-loader@1.2.9@vux-loader/src/before-template-compiler-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/template-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./node_modules/_vux@2.8.0@vux/src/components/toast/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-toast"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowMask && _vm.show),expression:"isShowMask && show"}],staticClass:"weui-mask_transparent"}),_vm._v(" "),_c('transition',{attrs:{"name":_vm.currentTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-toast",class:_vm.toastClass,style:({width: _vm.width})},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.type !== 'text'),expression:"type !== 'text'"}],staticClass:"weui-icon-success-no-circle weui-icon_toast"}),_vm._v(" "),(_vm.text)?_c('p',{staticClass:"weui-toast__content",style:(_vm.style),domProps:{"innerHTML":_vm._s(_vm.text)}}):_c('p',{staticClass:"weui-toast__content",style:(_vm.style)},[_vm._t("default")],2)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_toast = (esExports);
// CONCATENATED MODULE: ./node_modules/_vux@2.8.0@vux/src/components/toast/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("dbR2")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_toast,
  src_components_toast,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var _vux_2_8_0_vux_src_components_toast = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/_vue@2.6.12@vue/dist/vue.esm.js
var vue_esm = __webpack_require__("+RKF");

// EXTERNAL MODULE: ./node_modules/_fastclick@1.0.6@fastclick/lib/fastclick.js
var fastclick = __webpack_require__("iDdd");
var fastclick_default = /*#__PURE__*/__webpack_require__.n(fastclick);

// EXTERNAL MODULE: ./src/router/index.js
var router = __webpack_require__("YaEn");

// EXTERNAL MODULE: ./src/store/index.js
var store = __webpack_require__("IcnI");

// EXTERNAL MODULE: ./node_modules/_babel-runtime@6.26.0@babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("4YfN");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/_vux@2.8.0@vux/src/components/loading/index.vue + 3 modules
var loading = __webpack_require__("3CVM");

// EXTERNAL MODULE: ./node_modules/_vux@2.8.0@vux/src/components/spinner/spinner.js
var spinner = __webpack_require__("BqAQ");

// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.8.0@vux/src/components/spinner/index.vue
//
//
//
//


var types = ['android', 'ios', 'ios-small', 'bubbles', 'circles', 'crescent', 'dots', 'lines', 'ripple', 'spiral'];

/* harmony default export */ var components_spinner = ({
  name: 'spinner',
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      Object(spinner["a" /* default */])(_this.$el, _this.type, _this.size);
    });
  },

  props: {
    type: {
      type: String,
      default: 'ios'
    },
    size: String
  },
  computed: {
    styles: function styles() {
      if (typeof this.size !== 'undefined' && this.size !== '28px') {
        return {
          width: this.size,
          height: this.size
        };
      }
    },
    className: function className() {
      var rs = {};
      for (var i = 0; i < types.length; i++) {
        rs['vux-spinner-' + types[i]] = this.type === types[i];
      }
      return rs;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./node_modules/_vux@2.8.0@vux/src/components/spinner/index.vue
//
//
//
//


var spinner_types = ['android', 'ios', 'ios-small', 'bubbles', 'circles', 'crescent', 'dots', 'lines', 'ripple', 'spiral'];

/* harmony default export */ var src_components_spinner = ({
  name: 'spinner',
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      Object(spinner["a" /* default */])(_this.$el, _this.type, _this.size);
    });
  },

  props: {
    type: {
      type: String,
      default: 'ios'
    },
    size: String
  },
  computed: {
    styles: function styles() {
      if (typeof this.size !== 'undefined' && this.size !== '28px') {
        return {
          width: this.size,
          height: this.size
        };
      }
    },
    className: function className() {
      var rs = {};
      for (var i = 0; i < spinner_types.length; i++) {
        rs['vux-spinner-' + spinner_types[i]] = this.type === spinner_types[i];
      }
      return rs;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-186647c7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vux-loader@1.2.9@vux-loader/src/before-template-compiler-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/template-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./node_modules/_vux@2.8.0@vux/src/components/spinner/index.vue
var spinner_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"vux-spinner",class:_vm.className,style:(_vm.styles)})}
var staticRenderFns = []
var esExports = { render: spinner_render, staticRenderFns: staticRenderFns }
/* harmony default export */ var _vux_2_8_0_vux_src_components_spinner = (esExports);
// CONCATENATED MODULE: ./node_modules/_vux@2.8.0@vux/src/components/spinner/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("SHUn")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  src_components_spinner,
  _vux_2_8_0_vux_src_components_spinner,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var node_modules__vux_2_8_0_vux_src_components_spinner = (Component.exports);

// EXTERNAL MODULE: ./node_modules/_vuex@2.5.0@vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("HVJf");

// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./src/App.vue







/* harmony default export */ var App = ({
  name: 'app',
  components: {
    Loading: loading["a" /* default */],
    Spinner: node_modules__vux_2_8_0_vux_src_components_spinner
  },
  computed: extends_default()({}, Object(vuex_esm["b" /* mapState */])({
    isLoading: function isLoading(state) {
      return state.isLoading;
    }
  }))
});
// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vux-loader@1.2.9@vux-loader/src/script-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./src/App.vue







/* harmony default export */ var selectortype_script_index_0_src_App = ({
  name: 'app',
  components: {
    Loading: loading["a" /* default */],
    Spinner: node_modules__vux_2_8_0_vux_src_components_spinner
  },
  computed: extends_default()({}, Object(vuex_esm["b" /* mapState */])({
    isLoading: function isLoading(state) {
      return state.isLoading;
    }
  }))
});
// CONCATENATED MODULE: ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-151dcf11","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vux-loader@1.2.9@vux-loader/src/before-template-compiler-loader.js!./node_modules/_vux-loader@1.2.9@vux-loader/src/template-loader.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100%"},attrs:{"id":"app"}},[(!_vm.isLoading)?_c('router-view'):_c('div',{staticClass:"Loading"},[_c('div',{staticClass:"Loading-middle"},[_c('spinner',{attrs:{"type":"android"}})],1),_vm._v(" "),_c('p',[_vm._v("加载中，请稍等...")])])],1)}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("YxsZ")
}
var App_normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  selectortype_script_index_0_src_App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// EXTERNAL MODULE: ./node_modules/_amfe-flexible@2.2.1@amfe-flexible/index.js
var _amfe_flexible_2_2_1_amfe_flexible = __webpack_require__("/JRm");
var _amfe_flexible_2_2_1_amfe_flexible_default = /*#__PURE__*/__webpack_require__.n(_amfe_flexible_2_2_1_amfe_flexible);

// EXTERNAL MODULE: ./static/font/iconfont.css
var iconfont = __webpack_require__("uKUT");
var iconfont_default = /*#__PURE__*/__webpack_require__.n(iconfont);

// EXTERNAL MODULE: ./node_modules/_vux@2.8.0@vux/src/plugins/toast/index.js
var toast = __webpack_require__("N1Pi");

// EXTERNAL MODULE: ./node_modules/_vux@2.8.0@vux/src/plugins/loading/index.js
var plugins_loading = __webpack_require__("NYie");

// CONCATENATED MODULE: ./src/main.js













vue_esm["a" /* default */].use(toast["a" /* default */]);
vue_esm["a" /* default */].use(plugins_loading["a" /* default */]);

fastclick_default.a.attach(document.body);

vue_esm["a" /* default */].config.productionTip = false;

vue_esm["a" /* default */].directive('title', {
  inserted: function inserted(el, binding) {
    document.title = binding.value;
  }
});

/* eslint-disable no-new */
new vue_esm["a" /* default */]({
  router: router["a" /* default */],
  store: store["a" /* default */],
  render: function render(h) {
    return h(src_App);
  }
}).$mount('#app-box');

/***/ }),

/***/ "SHUn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("+RKF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("jxz8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__manage_index__ = __webpack_require__("zpdX");





var login = function login(resolve) {
  return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(7)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Luci")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var register = function register(resolve) {
  return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(3)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("1cHr")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var found = function found(resolve) {
  return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(5)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("jXIa")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var reset = function reset(resolve) {
  return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(6)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("9L7L")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var about = function about(resolve) {
  return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(2)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("M8Tx")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var focus = function focus(resolve) {
  return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(1)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Dkis")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var error = function error(resolve) {
  return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(4)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Kq85")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'login',
    component: login
  }, {
    path: '/register',
    name: 'register',
    component: register
  }, {
    path: '/found',
    name: 'found',
    component: found
  }, {
    path: '/reset',
    name: 'reset',
    component: reset
  }, {
    path: '/about',
    name: 'about',
    component: about
  }, {
    path: '/focus',
    name: 'focus',
    component: focus
  }, {
    path: '*',
    name: 'error',
    component: error
  }]
});

router.beforeEach(function (to, from, next) {
  __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('updateLoadingStatus', { isLoading: true });
  console.log(to);
  if (__WEBPACK_IMPORTED_MODULE_3__manage_index__["a" /* default */].cookie.get('token') && to.name !== 'login' && to.name !== 'register') {
    location.href = __WEBPACK_IMPORTED_MODULE_3__manage_index__["a" /* default */].protocol + 'member.' + __WEBPACK_IMPORTED_MODULE_3__manage_index__["a" /* default */].location + '/mobile/#/';
  } else {
    next();
  }
});

router.afterEach(function (to, from) {
  __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('updateLoadingStatus', { isLoading: false });
  if (from.name === 'reset') {
    //不在重置页面销毁信息
    __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('updatePhoneNum', { phone: '', userId: '' });
  }
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ "YxsZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dbR2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uKUT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zpdX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/_axios@0.17.1@axios/index.js
var _axios_0_17_1_axios = __webpack_require__("2sCs");
var _axios_0_17_1_axios_default = /*#__PURE__*/__webpack_require__.n(_axios_0_17_1_axios);

// EXTERNAL MODULE: ./node_modules/_qs@6.9.6@qs/lib/index.js
var lib = __webpack_require__("sh1p");
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./node_modules/_vux@2.8.0@vux/src/tools/cookie/index.js
var cookie = __webpack_require__("X6Vq");

// EXTERNAL MODULE: ./src/router/index.js
var router = __webpack_require__("YaEn");

// CONCATENATED MODULE: ./src/daoBaseConfig.js
/* eslint-disable */
var daoBaseConfig = {
	env: 'online',
	develop: {
		xcBasePath: "https://www.cxc555.com/xcWeb/",
		domain: '192.168.1.4',
		protocol: 'http://'
	},
	test: {
		xcBasePath: "/xcWeb/",
		domain: 'test.com',
		protocol: 'http://'
	},
	online: {
		xcBasePath: "/xcWeb/",
		domain: 'cxc555.com',
		protocol: 'https://'
	},
	getBasePath: function getBasePath() {
		if (daoBaseConfig.env == 'develop') {
			return daoBaseConfig.develop;
		}
		if (daoBaseConfig.env == 'test') {
			return daoBaseConfig.test;
		}
		if (daoBaseConfig.env == 'online') {
			return daoBaseConfig.online;
		}
	}
};
/* harmony default export */ var src_daoBaseConfig = (daoBaseConfig);
// CONCATENATED MODULE: ./src/manage/index.js







var daoBase = src_daoBaseConfig.getBasePath();

var manage = {
  /*LOCATION
  ** 网站主域,cookie存储
  */
  location: daoBase.domain, //cxc555.com//test.com
  protocol: daoBase.protocol,
  /*API接口
  **  使用方法:
  **    $xc.api.checkOutToken()
  */
  api: {
    header: daoBase.xcBasePath, //dev:http://192.168.0.106:8888/ ,,,http://192.168.0.106:8080/xcWeb/(http://192.168.0.113:8888/xcWeb/)  //build:http://192.168.0.59:8080/xcnet/  //http://192.168.0.57:8080/xcent/  //http://192.168.0.56:4009/
    checkOutToken: function checkOutToken() {

      return manage.api.header + 'login/checkOutToken';
    },
    phoneLogin: function phoneLogin() {

      return manage.api.header + 'userLogin/mobilephoneLogin';
    },
    getCodeWithLogin: function getCodeWithLogin() {

      return manage.api.header + 'userLogin/getCodeWithLogin';
    },
    getNickNameWithLogin: function getNickNameWithLogin() {

      return manage.api.header + 'userLogin/getNickNameWithLogin';
    },
    userCheckCodeWithLogin: function userCheckCodeWithLogin() {

      return manage.api.header + 'userLogin/userCheckCodeWithLogin';
    },
    userRetrieveLoginPwd: function userRetrieveLoginPwd() {

      return manage.api.header + 'userLogin/userRetrieveLoginPwd';
    },
    register: function register() {

      return manage.api.header + 'userLogin/register';
    },
    getCodeWithRegister: function getCodeWithRegister() {

      return manage.api.header + 'userLogin/getCodeWithRegister';
    },
    getQRCodeAfterRegister: function getQRCodeAfterRegister() {

      return manage.api.header + 'userLogin/getQRCodeAfterRegister';
    },
    wxLoginphone: function wxLoginphone() {

      return manage.api.header + 'userLogin/wx_loginphone';
    }
  },
  /*基础ajax封装
  **  使用方法:(get示例)
  **     Tips:页面需要引用import $xc from '~/manage/index'
  **    $xc.ajax.get(url, callback=>{
  **      console.log(callback.data)
  **    })
  */
  ajax: {
    get: function get(url, callback) {
      //https://bird.ioliu.cn/v1?url=为远程数据接口代理服务,解决get请求跨域问题
      _axios_0_17_1_axios_default.a.get('https://bird.ioliu.cn/v1?url=' + url).then(function (response) {
        if (response) {
          if (callback && typeof callback === 'function') {
            callback(response.data);
          }
        }
      });
      (function (response) {
        console.log(error);
      });
    },
    post: function post(url, param, callback) {
      router["a" /* default */].app.$vux.loading.show();

      _axios_0_17_1_axios_default.a.post(url, lib_default.a.stringify(param)).then(function (response) {
        if (response) {
          if (response.data.status === 0) {
            if (response.data.error) {
              router["a" /* default */].app.$vux.toast.text(response.data.error);
            }
            router["a" /* default */].app.$vux.loading.hide();
            return;
          }
          if (response.data.status === 2) {
            manage.cookie.delete('token');
            location.href = manage.protocol + 'www.' + manage.location + '/mobile/#/?returnUrl=' + location.href;
            router["a" /* default */].app.$vux.loading.hide();
            return;
          }
          if (response.data.token) {
            manage.cookie.set('token', response.data.token, 365);
          }
          if (callback && typeof callback === 'function') {
            callback(response.data);
            router["a" /* default */].app.$vux.loading.hide();
          }
        }
      }).catch(function (error) {
        console.log(error);
        router["a" /* default */].app.$vux.toast.text('粗错啦~请稍后重试');
        router["a" /* default */].app.$vux.loading.hide();
      });
      (function (response) {
        console.log(error);
        router["a" /* default */].app.$vux.loading.hide();
      });
    }
  },
  /*基础cookie封装
  **  使用方法:(set示例)
  **     Tips:页面需要引用import $xc from '~/manage/index'
  **    $xc.cookie.set(name, val, day)
  */
  cookie: {
    set: function set(name, val) {
      cookie["a" /* default */].set(name, val, {
        domain: manage.location,
        path: '/',
        expires: 30
      });
    },
    get: function get(name) {
      return cookie["a" /* default */].get(name);
    },
    delete: function _delete(name) {
      cookie["a" /* default */].remove(name, {
        domain: manage.location,
        path: '/'
      });
      /*VueCookie.delete(name)*/
    }
  },
  /*SPA单页应用获取地址栏Query参数封装函数
  **  使用方法:
  **     Tips:页面需要引用import $xc from '~/manage/index'
  **    $xc.getQueryString('returnUrl')
  */
  getQueryString: function getQueryString(name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    var r = window.location.href.split('#/')[1].substr(1).match(reg);
    if (r != null) return unescape(r[2]);return null;
  },
  /*JS判断输入字符串长度（汉字算两个字符，字母数字算一个）
  **  使用方法:
  **     Tips:页面需要引用import $xc from '~/manage/index'
  **    $xc.getByteLen(val)
  */
  getByteLen: function getByteLen(val) {
    var len = 0;
    for (var i = 0; i < val.length; i++) {
      var a = val.charAt(i);
      if (a.match(/[^\x00-\xff]/ig) != null) {
        len += 2;
      } else {
        len += 1;
      }
    }
    return len;
  },
  /*验证是否登录
  **  使用方法:
  **     Tips:页面需要引用import $xc from '~/manage/index'
  **    $xc.isLogin()
  */
  isLogin: function isLogin() {
    if (manage.cookie.get('token')) {
      _axios_0_17_1_axios_default.a.post(manage.api.checkOutToken(), lib_default.a.stringify({ token: manage.cookie.get('token') })).then(function (response) {
        if (response) {
          if (response.data.status === 0) {

            return;
          }
          if (response.data.status === 2) {
            return;
          }
          if (response.data.token) {
            manage.cookie.set('token', response.data.token, 365);
          }
          if (router["a" /* default */].app.$route.query.returnUrl) {
            location.href = router["a" /* default */].app.$route.query.returnUrl;
          } else {
            location.href = manage.protocol + 'member.' + manage.location + '/mobile/#/';
          }
        }
      }).catch(function (error) {
        console.log(error);
      });
      (function (response) {
        console.log(error);
      });
    }
  },
  /*判断是否在新APP中打开
  **
  */
  isNewAndroidApp: function isNewAndroidApp() {
    return navigator.userAgent.indexOf('Android_new_app') !== -1 ? true : false;
  }
};
/* harmony default export */ var src_manage = __webpack_exports__["a"] = (manage);

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.5477a18a4cafefdd4691.js